import { render, staticRenderFns } from "./vectorTaskUserManage.vue?vue&type=template&id=24fc5201&scoped=true&"
import script from "./vectorTaskUserManage.vue?vue&type=script&lang=js&"
export * from "./vectorTaskUserManage.vue?vue&type=script&lang=js&"
import style0 from "./vectorTaskUserManage.vue?vue&type=style&index=0&id=24fc5201&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24fc5201",
  null
  
)

export default component.exports